module.exports = __webpack_public_path__ + "img/获奖名单.e8e597fa.jpg";